export enum DistanceType {
  driving = 'driving',
  walking = 'walking',
}

